import React from 'react';
import moment from 'moment';

const useSortableData = (items, startDate, endDate, config = null) => {
  const [sortConfig, setSortConfig] = React.useState(config);

  const filterByDate = (item) => {
    if (!startDate && !endDate) {
      return true;
    }
    return moment(item.saleDate).toDate() >= moment(startDate).toDate()
        && moment(item.saleDate).toDate() <= moment(endDate).endOf('month').toDate();
  };

  const sortedItems = React.useMemo(() => {
    try {
      const sortableItems = [...items].filter(filterByDate);
      if (sortConfig !== null) {
        sortableItems.sort((a, b) => {
          if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
          }
          if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
          }
          return 0;
        });
      }
      return sortableItems;
    }
    catch (error) {
      return [];
    }
  }, [items, sortConfig, startDate, endDate]);

  const requestSort = (key) => {
    let direction = 'descending';
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'descending') {
      direction = 'ascending';
    }
    setSortConfig({ key, direction });
  };

  return { items: sortedItems, requestSort, sortConfig };
};

export default useSortableData;
